var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('tr',[_c('td',[_c('div',{staticClass:"m-auto h-2/4 w-0 border-l-2 border-solid border-[#5B7185]",class:{
        // 'border-[var(--v-success-base)]': item.status,
        // 'border-[#00000042]': !item.status,
      }}),_vm._v(" "),_c('v-icon',{staticClass:"w-[24px] block m-auto",staticStyle:{"display":"block"},attrs:{"color":_setup.disabled
          ? '#00000042'
          : (_setup.item.status && !_setup.item.overrideStatus) ||
              (_setup.item.overrideStatus && _setup.item.overrideReason)
            ? 'success'
            : '#00000042'}},[_vm._v("\n      "+_vm._s(_setup.disabled
          ? 'mdi-circle'
          : (_setup.item.status && !_setup.item.overrideStatus) ||
              (_setup.item.overrideStatus && _setup.item.overrideReason)
            ? 'mdi-check-circle'
            : 'mdi-circle')+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"m-auto h-2/4 w-0 border-none border-[#5B7185]",class:{
        // 'border-[var(--v-success-base)]': item.status,
        // 'border-[#00000042]': !item.status,
      }})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.$t('materiality')))]),_vm._v(" "),_c('td',[_c('v-chip',{attrs:{"disabled":""}},[_vm._v(" "+_vm._s(_setup.item.status || 'Not Assessed')+" ")]),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":"","disabled":_setup.disabled},on:{"click":() => {
          _setup.overrideEditing = !_setup.overrideEditing
        }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-pencil")])],1)],1),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(!_setup.overrideEditing),expression:"!overrideEditing"}]},[(
        [_setup.EnumIroType.PositiveImpact, _setup.EnumIroType.NegativeImpact].includes(
          _setup.item.type,
        ) &&
        (!_setup.item.severity ||
          !_setup.item.severityReason ||
          (!_setup.item.likelihood &&
            _setup.item.levelOfImpact === _setup.EnumIroLevelOfImpact.Potential))
      )?_c('v-row',[_c('span',{staticClass:"ml-4 mt-4"},[_vm._v(" "+_vm._s(_vm.$t('notFinished'))+" ")])]):_c('v-row',[_c('span',{staticClass:"ml-4 mt-4"},[_vm._v("\n        "+_vm._s([
            _setup.EnumIroOverrideStatus.Material,
            _setup.EnumIroOverrideStatus.NotMaterial,
          ].includes(_setup.item.overrideStatus)
            ? _setup.item.overrideReason
            : _vm.$t('assessInstruction'))+"\n      ")])])],1),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_setup.overrideEditing),expression:"overrideEditing"}]},[_c('ix-form-input-text-master',{attrs:{"value":_setup.item.overrideStatus,"title":_vm.$t('overrideStatusTitle'),"use-large-options":true,"use-text-field":false,"input-options":[
        {
          id: null,
          label: 'Use magnitude and likelihood thresholds',
        },
        { id: _setup.EnumIroOverrideStatus.Material, label: 'Material' },
        {
          id: _setup.EnumIroOverrideStatus.NotMaterial,
          label: 'Not Material',
        },
      ]},on:{"input":(val) => {
          _setup.updateIRO({
            iro: {
              id: _setup.item.id,
              overrideStatus: val,
            },
          }).then(() => {
            if (val === null) {
              _setup.overrideEditing = false
            }
          })
        }}}),_vm._v(" "),(_setup.item.overrideStatus != null)?_c('v-row',[_c('v-col',[_c('ix-form-input-text-master',{attrs:{"value":_setup.item.overrideReason,"title":_vm.$t('explainTitle'),"is-mandatory":true,"use-text-area":true},on:{"input":(val) => {
              _setup.updateIRO({
                iro: {
                  id: _setup.item.id,
                  overrideReason: val,
                },
              })
            }}})],1),_vm._v(" "),_c('v-col',[_c('v-btn',{staticClass:"mt-[55px]",attrs:{"color":"primary","disabled":!_setup.item.overrideReason},on:{"click":() => {
              _setup.overrideEditing = false
            }}},[_vm._v("\n          "+_vm._s(_vm.$t('btnDone'))+"\n        ")])],1)],1):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }